import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/",
        name: "dashboard",
        component: () => import("@/components/dashboard/_Dashboard.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewDashboardUI,
            breadcrumbs: {
                icon: "home-icon",
                paths: []
            },
            title: "navbar.dashboard"
        }
    }
];
